var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExportButtonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.814,
    height: 15.174,
    viewBox: "0 0 11.814 15.174",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23385",
    "data-name": "Group 23385",
    transform: "translate(-1720 -175.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11210",
    "data-name": "Path 11210",
    d: "M11.322,144H9.845v.985h.985v8.861H.985v-8.861h.985V144H.492a.492.492,0,0,0-.492.492v9.845a.492.492,0,0,0,.492.492h10.83a.492.492,0,0,0,.492-.492v-9.845A.492.492,0,0,0,11.322,144Z",
    transform: "translate(1720 35.758)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11211",
    "data-name": "Path 11211",
    d: "M91.261,1.848v6.84h.965V1.848L94.3,3.92l.683-.683L91.743,0,88.506,3.237l.683.683Z",
    transform: "translate(1634.164 175.414)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportButtonIcon);
export default __webpack_public_path__ + "static/media/export-button-icon.1e185755abdbb7e19216c6c984df6295.svg";
export { ForwardRef as ReactComponent };